import config from "config/config";
import { isFlagEnabled } from "js/utilities";

export async function validateUserInODS(
  ContractId,
  FirstName,
  LastName,
  IdentityNumber,
  PostalCode,
  MobileNumber,
  Dob
) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };

  let queryString =
    "ContractId=" +
    encodeURIComponent(ContractId) +
    "&FirstName=" +
    encodeURIComponent(FirstName) +
    "&LastName=" +
    encodeURIComponent(LastName) +
    "&IdentityNumber=" +
    IdentityNumber +
    "&PostalCode=" +
    PostalCode +
    "&MobileNumber=" +
    MobileNumber +
    "&Dob=" +
    Dob;

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/validate?" + queryString,
    options
  );

  if (!response.ok) {
    const data = await response.json();
    if (
      response.status === 401 &&
      data?.errors[0]?.description === "Token Invalid or Expired"
    ) {
      throw response;
    } else {
      if (
        response.status === 404 ||
        response.status === 403 ||
        response.status === 401
      ) {
        return data;
      } else {
        throw response;
      }
    }
  } else {
    const data = await response.json();
    return data;
  }
}
